/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsByRegionCount {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsByRegionCount.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsByRegionCount>): SecurityDashboardThreatsByRegionCount {
        let obj = Object.assign(new SecurityDashboardThreatsByRegionCount(), model);
        SecurityDashboardThreatsByRegionCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsByRegionCount>): SecurityDashboardThreatsByRegionCount {
        if (!model) return null;
        return SecurityDashboardThreatsByRegionCount.newInstance(<SecurityDashboardThreatsByRegionCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsByRegionCount) {
        if (!obj) return;

        models.SecurityDashboardThreatsByRegionCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsByRegionCount): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsByRegionCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threat_count === undefined) {
            this.threat_count = 0;
        }
    }

    /**
     * Visibility for the Cloud Provider
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Threats Count by region name
     */
    region: string;

    /**
     * Threats Total Count by region
     */
    threat_count: number;

}
